import { Component, OnDestroy, OnInit, forwardRef, Inject, Input } from '@angular/core';
import { ControlContainer, NgForm } from '@angular/forms';
import { ICardComponentInjectionToken } from '@infrastructure/ValidationMessages/ExternalValidationDirective';
import { ModalService } from '@infrastructure/Modal/ModalService';
import { BeneficiaryListTableEditComponent } from '../../beneficiary-list-table-edit.component';
import { TableEditBase } from '@infrastructure/TableEdit/TableEditBase';
//import { BenefitChoosen } from '@infrastructure/Documents/benefit-choosen.enum';
import { LegalRepresentationStateService } from '@infrastructure/Beneficiaries/legal-representation-state.service';


@Component({
  selector: 'beneficiary-observations',
  templateUrl: './beneficiary-observations.component.html',
  providers: [
    {
      provide: ICardComponentInjectionToken,
      useExisting: forwardRef(() => BeneficiaryListTableEditComponent)
    }],
  viewProviders: [{ provide: ControlContainer, useExisting: NgForm }],
  standalone: false
})

export class BeneficiaryObservationsComponent extends TableEditBase<models.BeneficiaryVM> implements OnInit, OnDestroy {

  @Input("cardData")
  public cardData: models.BeneficiaryObservationsVM = {} as models.BeneficiaryObservationsVM;

  @Input("hasLegalRepresentation")
  public hasLegalRepresentation: boolean;

  @Input("stateRL")
  public stateRL: number;

  constructor(@Inject(BeneficiaryListTableEditComponent) public parent: Component, private modalService: ModalService,
    private beneficiariesStateService: LegalRepresentationStateService) {
    super(parent, modalService);
    this.cardData =(<any>parent)._cardData;
  }


  ngOnInit(): void {
  }

  ngOnDestroy(): void {
  }


  public isNotStateRLDiferido(): boolean {
    const result = this.beneficiariesStateService
      .getStateDeferido(this.hasLegalRepresentation, this.stateRL?.toString());
    return !result;
  }
}
